import React, { useState, useEffect } from 'react'
import Alert from '../../../../feature/Alert';
import { useTranslation } from 'react-i18next';
import { GET_STATES, COMPANY_DETAILS, SAVE_COMPANY_DETAILS } from '../../../../data/url';
import httpClient from '../../../../http/HttpRequest';
import FormLayout from '../../layout/FormLayout';

export default function CompanyProfile() {

     const { t } = useTranslation();
     const [directSubmit, setDirectSubmit] = useState(1);
     const [companyData, setcompanyData] = useState({});     
     const [formData, setFormData] = useState({
          formTitle: 'Company Profile',
          formFields: [
               { label: 'name', id: 'company_name', type: 'text', name: 'company_name', value: '', required: true, className: "col-md-4" },
               { label: 'address', id: 'address', type: 'textarea', name: 'address', value: '', className: "col-md-4" },
               { label: 'city', id: 'city', type: 'text', name: 'city', value: '', className: "col-md-4" },
               { label: 'pincode', id: 'pincode', type: 'number', name: 'pincode', value: '', className: "col-md-4" },
               { label: 'state', id: 'state', type: 'select', name: 'state', value: '', options: [], className: "col-md-4" },
               { label: 'email', id: 'email', type: 'email', name: 'email', value: '', className: "col-md-4" },
               { label: 'phone_number', id: 'phone_number', type: 'text', name: 'phone_number', value: '', className: "col-md-4" },
               { label: 'office_number', id: 'office_number', type: 'text', name: 'office_number', value: '', className: "col-md-4" },
               { label: 'website_url', id: 'website_url', type: 'text', name: 'website_url', value: '', className: "col-md-4" },
               { label: 'desc', id: 'description', type: 'textarea', name: 'description', value: '', className: "col-md-4" },
               { label: 'industry_type', id: 'industry_type', type: 'text', name: 'industry_type', value: '', className: "col-md-4" },
               { label: 'reg_date', id: 'reg_date', type: 'date', name: 'date_founded', value: '', className: "col-md-4" },
               { label: 'registration_number', id: 'registration_number', type: 'text', name: 'registration_number', value: '', className: "col-md-4" },
               { label: 'tin', id: 'tin', type: 'text', name: 'tin', value: '', className: "col-md-4" },
               { label: 'contact_person', id: 'contact_person', type: 'text', name: 'contact_person', value: '', className: "col-md-4" },
               { label: 'prefix', id: 'prefix', type: 'text', name: 'prefix', value: '', className: "col-md-4" },

          ],
          formErrors: { company_name: '', address: '', city: '', pincode: '', state: '', email: '', phone_number: '', office_number: '', website_url: '', description: '', registration_number: '', industry_type: '', tin: '', date_founded: '', contact_person: '',prefix:'' },
     });

     useEffect(() => {
          getState();
          getCompanyDetails();
     }, []);

     const getState = async (e) => {
          const res = await httpClient.post(GET_STATES, {});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {                   
                    let options = [];
                    result.data.forEach((row, index) => {
                         options.push({ label: row.name, value: row.id });
                    });
                    updateFormFieldOptions(options, 'state');
               }
          }
     }

     const updateFormFieldOptions = (newOptions, fieldName) => {
          setFormData(prevFormData => {
               const updatedFormFields = prevFormData.formFields.map(field => {
                    if (field.name === fieldName) {
                         return {
                              ...field,
                              options: newOptions,
                         };
                    }
                    return field;
               });
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     };

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setcompanyData(result.data);
                    setFormData(prevFormData => {
                         const updatedFormFields = prevFormData.formFields.map(field => {
                              if (field.name in result.data) {
                                   field.value = result.data[field.name];
                              }
                              return field;
                         });
                         return {
                              ...prevFormData,
                              formFields: updatedFormFields,
                         };
                    });
               } else {
                    Alert.error(res.message);
               }
          }
     };

     function handleFieldChange(fieldName, value) {
          setDirectSubmit(0);
          setFormData((prevFormData) => {
               const updatedFormFields = prevFormData.formFields.map((field) =>
                    field.name === fieldName ? { ...field, value: value } : field
               );
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     }

     function handleFieldBlur(fieldName, value) {
          setDirectSubmit(0);
          validateField(fieldName, value);
     }

     function validateField(fieldName, value) {
          setFormData((prevFormData) => {
               const updatedErrors = { ...prevFormData.formErrors };
               if (fieldName === 'company_name') {
                    updatedErrors.company_name = value.trim() === '' ? 'field_required' : '';
               }
               return {
                    ...prevFormData,
                    formErrors: updatedErrors,
               };
          });

          return formData.formErrors;

     }

     function handleSubmit(e) {
          e.preventDefault();
          let post = {};
          let hasErrors = false;
          const updatedFormFields = formData.formFields.map((field) => {
               const allError = validateField(field.name, field.value);
               const error = allError[field.name];
               if (error !== '' && typeof error !== 'undefined') {
                    hasErrors = true;
               } else {
                    post[field.name] = field.value;
               }
               return field;
          });
          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
          }));
          if (!hasErrors && directSubmit === 0) {
               post['company_id'] = companyData.company_id;
               subtmitData(post);
          } else {
               Alert.warning(t('you_did_not_change_anything'));
          }
     }

     const subtmitData = async (post) => {
          post['state'] = post['state'] === '' ? null : post['state'];
          const res = await httpClient.post(SAVE_COMPANY_DETAILS, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     function handleReset() {
          const updatedFormFields = formData.formFields.map((field) => ({
               ...field,
               value: '',
          }));

          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
               formErrors: {},
          }));
     }

     return (
          <div className='col-md-12 m-auto'>
               <FormLayout
                    formTitle={formData.formTitle}
                    formFields={formData.formFields}
                    formErrors={formData.formErrors}
                    onFieldChange={handleFieldChange}
                    onFieldBlur={handleFieldBlur}
                    onSubmit={handleSubmit}
                    handleReset={handleReset}
               />
          </div>

     )
}
